import React, { useMemo } from 'react';
import * as PropTypes from 'prop-types';

import { getFieldProps } from '../../../../utils/fields/getFieldProps';
import { HomeAddressRowModeView } from './HomeAddressRowModeView';
import { HomeAddressColumnModeView } from './HomeAddressColumnModeView';
import { getPhoneWithoutUSCode } from '../../../../utils/getPhone';

export function HomeAddressFormSection({
  targetCountryEntity,
  formatMessage,
  postalCode,
  address1,
  address2,
  city,
  state,
  country,
  homePhone,
  onChange,
  onCountryChange,
  countryList,
  validateErrors,
  isZipApplicable,
  statesList,
  zipLimit,
  rowMode = false,
  isDisabled,
  zipExamples,
  homePhoneRequired,
  cityRequired,
  address1Required,
  isAppointmentPatientForm,
  isFormSubmitted,
}) {
  const makeProfileField = getFieldProps(formatMessage, onChange);
  const handleCountryChange = useMemo(
    () => data => {
      if (!data) return;
      if (country === data || country === data.label) {
        onCountryChange(data);
        return;
      }
      onCountryChange(data);
    },
    [country, targetCountryEntity, address1, address2, city, homePhone],
  );

  const upperCasedPostalCode = postalCode
    ? postalCode.toUpperCase()
    : postalCode;

  return rowMode ? (
    <HomeAddressRowModeView
      zipLimit={zipLimit}
      validateErrors={validateErrors}
      statesList={statesList}
      onCountryChange={onCountryChange}
      countryList={countryList}
      onChange={onChange}
      makeProfileField={makeProfileField}
      address1={address1}
      address2={address2}
      city={city}
      country={country}
      handleCountryChange={handleCountryChange}
      homePhone={getPhoneWithoutUSCode(homePhone)}
      isZipApplicable={isZipApplicable}
      postalCode={upperCasedPostalCode}
      state={state}
      targetCountryEntity={targetCountryEntity}
      isDisabled={isDisabled}
      formatMessage={formatMessage}
      zipExamples={zipExamples}
      homePhoneRequired={homePhoneRequired}
      cityRequired={cityRequired}
      address1Required={address1Required}
      isAppointmentPatientForm={isAppointmentPatientForm}
      isFormSubmitted={isFormSubmitted}
    />
  ) : (
    <HomeAddressColumnModeView
      zipLimit={zipLimit}
      validateErrors={validateErrors}
      statesList={statesList}
      onCountryChange={onCountryChange}
      countryList={countryList}
      onChange={onChange}
      makeProfileField={makeProfileField}
      address1={address1}
      address2={address2}
      city={city}
      country={country}
      handleCountryChange={handleCountryChange}
      homePhone={homePhone}
      isZipApplicable={isZipApplicable}
      postalCode={upperCasedPostalCode}
      state={state}
      targetCountryEntity={targetCountryEntity}
      isDisabled={isDisabled}
      formatMessage={formatMessage}
      zipExamples={zipExamples}
      isAppointmentPatientForm={isAppointmentPatientForm}
    />
  );
}

HomeAddressFormSection.propTypes = {
  formatMessage: PropTypes.func,
  postalCode: PropTypes.string,
  address1: PropTypes.string,
  address2: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  country: PropTypes.object,
  homePhone: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  statesList: PropTypes.array,
  countryList: PropTypes.array,
  zipLimit: PropTypes.number,
  onCountryChange: PropTypes.func,
  isZipApplicable: PropTypes.bool,
  validateErrors: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  targetCountryEntity: PropTypes.object,
  rowMode: PropTypes.bool,
  isDisabled: PropTypes.func,
  zipExamples: PropTypes.string,
  homePhoneRequired: PropTypes.bool,
  cityRequired: PropTypes.bool,
  address1Required: PropTypes.bool,
  isAppointmentPatientForm: PropTypes.bool,
  isFormSubmitted: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/HomeAddress/HomeAddressFormSection/index.jsx